<style scoped>
.xybox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.xytitle {
  width: 90%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
p {
  width: 100%;
  font-size: 38px;
}
.xy {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #bbbbbb;
  padding: 5px;
}
.chbox {
  width: 100%;
  height: 100px;
}
.el-checkbox__inner {
  width: 100px;
  height: 100px;
}
/* 容器 */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: 10px;
}

/* 隐藏浏览器的默认复选框 */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* 创建自定义复选框 */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* 在鼠标悬停时，添加灰色背景色 */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* 当复选框被选中时，添加一个蓝色背景 */
.container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* 创建复选标记/指示器（未选中时隐藏）*/
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* 选中时显示复选标记 */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* 设置复选标记/指示器的样式 */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.ppp {
  margin-top: 10px;
  padding: 10px 80px;
  font-size: 30px;
}
.english {
  width: 90%;
  display: flex;
  justify-content: right;
  position: absolute;
 left: 35px;
  top: 85px;
}
.english {
  width: 90%;
  display: flex;
  justify-content: right;
  position: absolute;
  left: 20px;
  top: 95px;
}
.but{
  padding: 5px 10px;
}
</style>
<template>
  <div class="xybox">
    <div v-if="0" class="xytitle">
      <p>客户使用协议</p>
      <div class="xy">
        <h3>1、受你方委托并根据你方要求，我司开发的软件为合法产品，不得用于非法用途;</h3>
        <h3>2、我司为你方开发的软件程序仅用于兴趣研究、爱好学习和合法用途;</h3>
        <h3>3、你方利用我司开发的软件程序进行非法活动所产生的一切刑事、民事等责任均与我司无关，你方须独自承担由此造成的责任;</h3>
        <h3>4、你方保证对我司开发的软件程序技术，数据予以保密，如有恶意泄漏造成我司的一切拐失，均中你方承担。</h3>
      </div>

      <label class="container">
        我已阅读并同意
        <input type="checkbox" v-model="checked" />
        <span class="checkmark"></span>
      </label>

      <el-button class="ppp" type="primary" @click="signout()">确认</el-button>
    </div>

    <div  class="xytitle">
      <p>Customer Use Agreement</p>
      <div class="xy">
        <h3>1.Entrusted by you and according to your requirements, the software developed by our company is a legal product and shall not be used for illegal purposes.</h3>
        <h3>2.The software program developed by our company for you is only used for interest research, hobby learning and legal purposes.</h3>
        <h3>3.You use the software program developed by our company to carry out illegal activities arising from all the criminal, civil and other liabilities have nothing to do with our company, you have to bear the responsibility caused by this alone.</h3>
        <h3>4.you ensure that our development of software program technology, data to be confidential, such as malicious leakage caused by the Division I of all the abduction loss, are in your side to bear.</h3>
      </div>

      <label class="container">
        I have read and agree to
        <input type="checkbox" v-model="checked" />
        <span class="checkmark"></span>
      </label>

      <el-button class="ppp" type="primary" @click="signout()">Agree</el-button>
    </div>

    <!-- <div class="english">
      <div>
        <el-button class="but" v-if="English" type="info" @click="English=!English">English</el-button>
        <el-button class="but" v-if="!English" @click="English=!English" type="info">中文</el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      checked: false,
      English: false
    };
  },
  methods: {
    signout() {
      if (!this.checked && this.English) {
        this.$message.error("请阅读并同意客户使用协议");
        
        return;
      }
      if (!this.checked && !this.English) {
        this.$message.error(
          "Please read and agree to the customer use agreement"
        );
        return;
      }

      let token = sessionStorage.getItem("token");
      axios
        .post(`/puserSys/puser/logout?userid=${+token}`)
        .then(res => {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("tokenUrl");
          sessionStorage.removeItem("loginInfopassword");
          sessionStorage.removeItem("phone");
          sessionStorage.removeItem("aggree0");
          sessionStorage.removeItem("aggree3");
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "sign out success"
          });
        })
        .catch(() => {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("tokenUrl");
          sessionStorage.removeItem("loginInfopassword");
          sessionStorage.removeItem("phone");
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "sign out success"
          });
        });
    }
  }
};
</script>


